import { LOCALES, LOCALE_CODES, type LocaleCode } from '../i18n';
import { useT } from '../hooks';

interface Props {
  current: LocaleCode;
  onSelect: (code: LocaleCode) => void;
  onClose: () => void;
}

export function LanguagePicker({ current, onSelect, onClose }: Props) {
  const t = useT();

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal modal--lang" onClick={(e) => e.stopPropagation()}>
        <h2 className="modal__title">{t.language.title}</h2>
        <p className="muted">{t.language.description}</p>

        <div className="langlist">
          {LOCALE_CODES.map((code) => {
            const meta = LOCALES[code].meta;
            return (
              <button
                key={code}
                type="button"
                lang={meta.tag}
                className={`langcard ${code === current ? 'langcard--active' : ''}`}
                onClick={() => {
                  onSelect(code);
                  onClose();
                }}
              >
                <span className="langcard__name">{meta.name}</span>
                <span className="langcard__english">{meta.english}</span>
                {code === current && (
                  <span className="langcard__check" aria-hidden="true">
                    ✓
                  </span>
                )}
              </button>
            );
          })}
        </div>

        <div className="modal__actions">
          <button type="button" className="btn btn--primary" onClick={onClose}>
            {t.common.done}
          </button>
        </div>
      </div>
    </div>
  );
}
